import 'react';

var AuthMethod = /* @__PURE__ */ ((AuthMethod2) => {
  AuthMethod2["NoAuth"] = "NoAuth";
  AuthMethod2["BasicAuth"] = "BasicAuth";
  AuthMethod2["OAuthForward"] = "OAuthForward";
  AuthMethod2["CrossSiteCredentials"] = "CrossSiteCredentials";
  return AuthMethod2;
})(AuthMethod || {});

export { AuthMethod };
//# sourceMappingURL=types.js.map
